import * as React from "react";
import type { SVGProps } from "react";
const SvgGlobe05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.404 21.298a9.6 9.6 0 1 1-2.4-18.898c4.896 0 8.935 3.664 9.526 8.4M2.604 15.6h2.8a2 2 0 0 0 2-2V11a2 2 0 0 1 2-2h2a2 2 0 0 0 2-2V3.6m6.048 14.422 2.748-.95a.589.589 0 0 0 .026-1.103l-6.813-2.726a.589.589 0 0 0-.77.752l2.595 6.988c.19.51.911.512 1.102.002z"
    />
  </svg>
);
export default SvgGlobe05;
